<script setup lang="ts">
import Label from '@/components/label/Index.vue'
</script>

<template>
  <Label tag="label">
    <slot />
  </Label>
</template>
